import Button from '@platform-ui-common/components/Button/index.js';
import Color from '@platform-ui-common/utilities/Color.js';
import { ReactNode, useCallback } from 'react';
import useSnackbar, { SnackbarKey } from './useSnackbar/index.js';

export default function useErrorIndicator(): (message?: ReactNode, retry?: () => void) => void {
  const { showSnackbar } = useSnackbar();
  return useCallback(
    (message = 'Something went wrong!', retry?: () => void): SnackbarKey =>
      showSnackbar(
        message,
        retry ? (
          <Button variant="text" textColor={Color.Link} onClick={retry}>
            Try Again
          </Button>
        ) : undefined,
      ),
    [showSnackbar],
  );
}
